module.exports = __webpack_public_path__ + "img/distribution-points-map.892d5267.svg";